// Estado de la barra de progreso superior (TopProgressBar): cuántas cargas
// está esperando la persona ahora mismo.
//
// Cuenta las pantallas que se cargan (Suspense) y las peticiones que salen
// poco después de un clic, una tecla o un cambio de página. Las consultas
// periódicas en segundo plano (notificaciones, chat, viaje activo…) no la
// encienden: saldría cada pocos segundos sin que nadie esté esperando.

const FOREGROUND_WINDOW_MS = 2000;

let pending = 0;
// Al abrir la app todo lo que se carga es "en primer plano".
let lastActivity = Date.now();
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(pending));

export const loadingStart = () => {
  pending += 1;
  emit();
};

export const loadingDone = () => {
  pending = Math.max(0, pending - 1);
  emit();
};

export const subscribeLoading = (fn) => {
  listeners.add(fn);
  fn(pending);
  return () => listeners.delete(fn);
};

export const markUserActivity = () => {
  lastActivity = Date.now();
};

export const isForeground = () => Date.now() - lastActivity < FOREGROUND_WINDOW_MS;

if (typeof window !== "undefined") {
  ["pointerdown", "keydown", "submit", "popstate"].forEach((ev) =>
    window.addEventListener(ev, markUserActivity, { capture: true, passive: true })
  );
}
